import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OrgDto} from "../dto/org.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {NotificationDto} from "../dto/notification.dto";
import {VoidDto} from "../dto/void.dto";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class NotificationRepo {


  private readonly notificationAllRead = '/v1/org/{orgId}/notification/all';
  private readonly notificationMarkAsRead = '/v1/org/{orgId}/notification/{id}/read';

  private readonly http: HttpClient = inject(HttpClient);

  public getAll(org: OrgDto): Observable<WrapperDto<NotificationDto>> {
    const url = UrlBuilder.builder().addPath(this.notificationAllRead).addParam('orgId', org.id).build();
    return this.http.get<WrapperDto<NotificationDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }

  public markAsRead(org: OrgDto, notificationId: string): Observable<WrapperDto<VoidDto>> {
    const url = UrlBuilder.builder().addPath(this.notificationMarkAsRead)
      .addParam('orgId', org.id).addParam('id', notificationId).build();
    return this.http.post<WrapperDto<VoidDto>>(url.getUrl(), {}, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
